export default {
  production: true,
  legalQuestionnaireReadOnly: false,
  Okta: {
    issuer: 'https://preview.wcgclinical.com/oauth2/default', // Set from Jenkins credentials: okta_issuer
    baseUrl: 'https://preview.wcgclinical.com', // Set from Jenkins credentials: okta_baseurl
    clientId: '0oah9cw646lKZgFAN1d7', // Set from Jenkins credentials: okta_clientid
    redirectUri:
      'https://tst-ereviewmanager.wcgclinical.com/auth/login/callback', // Set from Jenkins credentials: okta_redirecturi
    disableHttpsCheck: true,
    useClassicEngine: false,
    postLogoutRedirectUri: 'https://tst-clinsphere.wcgclinical.com',
  },
  clinsphereUrl: 'https://tst-clinsphere.wcgclinical.com',
  joBaseUrl: 'https://tst-ereviewmanager.wcgclinical.com/submitassist',
  // Must match ai-irb's IDP_ENVIRONMENT.
  oktaGroupEnv: 'TST',
  irisApi: 'https://tst-be-ereviewmanager.wcgclinical.com',
  jemmaApi: 'https://tst-clinsphere.wcgclinical.com/jemma/',
  jemmaEventSource: '7f90a79ddce16dd9350fabd4b2370744',
  workspaceNewVersion: true,
  enabledTask: false,
  irisWS: 'wss://tst-be-ereviewmanager.wcgclinical.com/ws',
  appBaseHref: 'https://tst-ereviewmanager.wcgclinical.com',
  oneTrustDomainScript: '01977f3a-886e-7ac1-bc39-2b1a04d51400',
  newRelic: {
    enabled: true,
    accountID: '211490',
    trustKey: '211490',
    agentID: '1103450721',
    licenseKey: 'NRBR-4310019effceddf7e30',
    applicationID: '1103450721',
  },
  maxSessionLength: 24 * 60 * 60 * 1000,
  sessionTimeout: 58 * 60 * 1000,
  sessionGracePeriod: 2 * 60 * 1000,
  checkForOneTrustConsent: true,
  walkMeUrl:
    'https://cdn.walkme.com/users/ee75fa9a9e0e4c46bfdcf49e30de33b9/test/walkme_ee75fa9a9e0e4c46bfdcf49e30de33b9_https.js', // Set from Jenkins credentials
  talkdesk: {
    accountId: '',
    region: 'td-us-1',
    touchpointId: '1d5861df7498439c9c791a8a6f404f89',
    scriptUrl: 'https://talkdeskchatsdk.talkdeskapp.com/v2/talkdeskchatsdk.js',
    config: {
      enableValidation: true,
      enableEmoji: true,
      enableAttachments: true,
      showInitialScreen: true,
      chatTitle: 'Live chat',
      initialScreenSubmitButtonLabel: 'Start Chat',
      website_url: 'https://tst-ereviewmanager.wcgclinical.com',
    },
  },
  enableReviewerMaterials: true,
  showDashboardConfigPanel: false,
};
